import moment from "moment";

// File kinds for the Files and Info panels: a filter group, and the colour of the type tile
const KINDS = {
  image: { group: "images", color: "#10B981", exts: ["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "heic"] },
  pdf: { group: "documents", color: "#EF4444", exts: ["pdf"] },
  doc: { group: "documents", color: "#2563EB", exts: ["doc", "docx", "txt", "md", "rtf", "odt"] },
  sheet: { group: "documents", color: "#059669", exts: ["xls", "xlsx", "csv", "ods"] },
  slides: { group: "documents", color: "#F97316", exts: ["ppt", "pptx", "odp"] },
  video: { group: "other", color: "#8B5CF6", exts: ["mp4", "mkv", "avi", "mov", "webm"] },
  audio: { group: "other", color: "#EC4899", exts: ["mp3", "wav", "ogg", "m4a"] },
  archive: { group: "other", color: "#D97706", exts: ["zip", "rar", "7z", "tar", "gz"] },
};

export const FILE_FILTERS = [
  { key: "all", label: "All" },
  { key: "images", label: "Images" },
  { key: "documents", label: "Documents" },
  { key: "other", label: "Other" },
];

export const getFileKind = (extension = "") => {
  const ext = extension.toLowerCase();
  const kind = Object.values(KINDS).find((entry) => entry.exts.includes(ext));
  return kind || { group: "other", color: "#64748B" };
};

// The file's own name: the stored path without folders or the upload prefix
export const getFileDisplayName = (filePath = "") =>
  filePath.split(/[\\/]/).pop().replace(/^message_media\//, "");

// Every file in a list of messages, newest first
export const getFilesFromMessages = (messages = []) =>
  messages
    .flatMap((message) =>
      (message.files || []).map((filePath) => {
        const name = getFileDisplayName(filePath);
        const extension = name.includes(".") ? name.split(".").pop() : "";
        return {
          path: filePath,
          name,
          extension: extension.toUpperCase(),
          kind: getFileKind(extension),
          date: message.createdAt,
        };
      })
    )
    .sort((a, b) => new Date(b.date) - new Date(a.date));

// Day heading for a group of files: Today, Yesterday, or the date
export const formatFileDay = (date) => {
  const day = moment(date);
  if (day.isSame(moment(), "day")) return "Today";
  if (day.isSame(moment().subtract(1, "day"), "day")) return "Yesterday";
  return day.format("MMM D, YYYY");
};

// The kind's key ("image", "video", "pdf", ...) for an extension, or "file"
export const getFileKindKey = (extension = "") =>
  Object.keys(KINDS).find((key) => KINDS[key].exts.includes(extension.toLowerCase())) || "file";
